import { render, staticRenderFns } from "./InsurancePolicyDetails.vue?vue&type=template&id=50ac4116&"
import script from "./InsurancePolicyDetails.vue?vue&type=script&lang=ts&"
export * from "./InsurancePolicyDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports